import "./Breadcrumb.css";

export default function Breadcrumb() {
  return (
    <section className="breadcrumb">

      <div className="container">

        <span>HOME</span>

        <span className="separator">&gt;</span>

        <span>SOLUTIONS</span>

        <span className="separator">&gt;</span>

        <span>DEMO</span>

      </div>

    </section>
  );
}